/** Live countdown until review window ends (ISO UTC or seconds remaining). */

export function resolveReviewWindowEndsAtMs(
  endsAt?: string | null,
  secondsUntil?: number | null,
  nowMs = Date.now(),
): number | null {
  if (typeof endsAt === 'string' && endsAt.trim()) {
    const parsed = new Date(endsAt).getTime();
    if (Number.isFinite(parsed)) {
      return parsed;
    }
  }
  if (typeof secondsUntil === 'number' && Number.isFinite(secondsUntil) && secondsUntil >= 0) {
    return nowMs + secondsUntil * 1000;
  }
  return null;
}

export function formatReviewWindowCountdown(
  endsAtMs: number | null,
  nowMs = Date.now(),
): { label: string; expired: boolean; remainingMs: number } {
  if (endsAtMs == null || !Number.isFinite(endsAtMs)) {
    return { label: '', expired: true, remainingMs: 0 };
  }
  const remainingMs = Math.max(0, endsAtMs - nowMs);
  if (remainingMs <= 0) {
    return { label: '00:00:00', expired: true, remainingMs: 0 };
  }

  const totalSeconds = Math.floor(remainingMs / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  const pad = (n: number) => String(n).padStart(2, '0');

  return {
    label: `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`,
    expired: false,
    remainingMs,
  };
}
